import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SERVICES_CONSTANTS } from '../utils/constants';
import { StringUtils } from '../utils/stringUtils';
import { AdminCategory, AdminSubcategory, FormField, ImageType } from '../model/category-management-dto';

/**
 * Servicio de gestión de categorías/subcategorías del administrador.
 * Todos los endpoints van bajo /admin/management/categories y requieren
 * el token de administrador (lo agrega el interceptor).
 */
@Injectable({
  providedIn: 'root'
})
export class CategoryManagementService {

  private baseUrl: string = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private stringUtils: StringUtils
  ) {}

  private managementUrl(...paths: string[]): string {
    return this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.ADMIN_PATH.MAIN,
      SERVICES_CONSTANTS.ADMIN_PATH.CATEGORIES.MAIN,
      ...paths
    );
  }

  getCategories(): Observable<any> {
    return this.http.get<any>(this.managementUrl());
  }

  createCategory(body: {
    name: string; active: boolean; iconName: string;
    backgroundColor?: string; imageFileId?: string;
  }): Observable<any> {
    return this.http.post<any>(this.managementUrl(), body);
  }

  updateCategory(categoryId: string, body: Partial<{
    name: string; active: boolean; iconName: string;
    backgroundColor: string; imageFileId: string;
  }>): Observable<any> {
    return this.http.put<any>(this.managementUrl('/', categoryId), body);
  }

  createSubcategory(body: {
    categoryId: string; subcategoryName: string; active: boolean;
    imageIconFileId?: string; imageTitleFileId?: string; fields: FormField[];
  }): Observable<any> {
    return this.http.post<any>(
      this.managementUrl(SERVICES_CONSTANTS.ADMIN_PATH.CATEGORIES.SUBCATEGORIES), body);
  }

  updateSubcategory(subcategoryId: string, body: Partial<{
    subcategoryName: string; active: boolean; categoryId: string;
    imageIconFileId: string; imageTitleFileId: string; fields: FormField[];
  }>): Observable<any> {
    return this.http.put<any>(
      this.managementUrl(SERVICES_CONSTANTS.ADMIN_PATH.CATEGORIES.SUBCATEGORIES, '/', subcategoryId), body);
  }

  getSubcategory(subcategoryId: string): Observable<any> {
    return this.http.get<any>(
      this.managementUrl(SERVICES_CONSTANTS.ADMIN_PATH.CATEGORIES.SUBCATEGORIES, '/', subcategoryId));
  }

  uploadImage(file: File, imageType: ImageType): Observable<any> {
    const extension = (file.name.split('.').pop() || 'png').toLowerCase();
    const formData = new FormData();
    formData.append('imageType', imageType);
    formData.append('extension', extension);
    formData.append('file', file);
    return this.http.post<any>(
      this.managementUrl(SERVICES_CONSTANTS.ADMIN_PATH.CATEGORIES.UPLOAD_IMAGE), formData);
  }
}
